import * as yup from 'yup'

export const EndorsementsSchema = yup.object({
  tanker: yup.boolean(),
  twic: yup.boolean(),
  doubleTrailer: yup.boolean(),
  hazmat: yup.boolean(),
})

export type TEndorsementsSchema = yup.InferType<typeof EndorsementsSchema>
